
import { mapMutations, mapState } from 'vuex'
import { RequestStaffHours } from '../types/invoice_line_items'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip/NrTooltip.vue'
import InvoiceItemMenu from './InvoiceItemMenu.vue'
import truncate from 'lodash/truncate'

export default {
  components: {
    InvoiceItemMenu,
    NrTooltip
  },

  computed: {
    ...mapState('request_show', ['requestStaffHours']),

    staffHours(): Array<RequestStaffHours> {
      const hours: { string: RequestStaffHours[] } = this.requestStaffHours
      return Object.values(hours)
        .flat()
        .filter(
          (staffHourItem: RequestStaffHours) =>
            staffHourItem.invoice_id == null &&
            !staffHourItem.exclude_time_on_invoice
        )
    }
  },

  methods: {
    ...mapMutations('request_show', ['setSelectedStaffHour', 'setActiveModal']),

    truncate,

    onEdit(staffHour: RequestStaffHours) {
      this.setSelectedStaffHour(staffHour)
      this.setActiveModal('editStaffTime')
    },

    onDelete(staffHour: RequestStaffHours) {
      this.setSelectedStaffHour(staffHour)
      this.setActiveModal('deleteStaffHourConfirmationDialog')
    }
  }
}
